import { ItemPickerModel } from 'src/app/shared/components/item-picker/models/itemPickerModel';

export enum TeamEvaluationDetailsReportFields {
  evaluationId = 'evaluationId',
  evaluationName = 'evaluationName',
  evaluateeId = 'evaluateeId',
  evaluateePosition = 'evaluateePosition',
  evaluateeFullName = 'evaluateeFullName',
  evaluateeFirstName = 'evaluateeFirstName',
  evaluateeLastName = 'evaluateeLastName',
  evaluateeEmail = 'evaluateeEmail',
  seatId = 'seatId',
  teamId = 'teamId',
  teamName = 'teamName',
  teamStartDate = 'teamStartDate',
  teamEndDate = 'teamEndDate',
  seatStartDate = 'seatStartDate',
  seatEndDate = 'seatEndDate',
  teamCustomFields = 'teamCustomFields',
  responses = 'responses',
  fullName = 'fullName',
  externalSystemId = 'externalSystemId'
}

export const TeamEvaluationDetailsReportSystemColumns: ItemPickerModel[] = [
  new ItemPickerModel(TeamEvaluationDetailsReportFields.evaluationName, '', 'Evaluation Name'),
  new ItemPickerModel(TeamEvaluationDetailsReportFields.teamId, '', 'Team Id'),
  new ItemPickerModel(TeamEvaluationDetailsReportFields.teamName, '', 'Team Name'),
  new ItemPickerModel(TeamEvaluationDetailsReportFields.teamStartDate, '', 'Team Start Date'),
  new ItemPickerModel(TeamEvaluationDetailsReportFields.teamEndDate, '', 'Team End Date'),
  new ItemPickerModel(TeamEvaluationDetailsReportFields.seatStartDate, '', 'Seat Start Date'),
  new ItemPickerModel(TeamEvaluationDetailsReportFields.seatEndDate, '', 'Seat End Date'),
  new ItemPickerModel(TeamEvaluationDetailsReportFields.evaluateePosition, '', 'Position'),
  new ItemPickerModel(TeamEvaluationDetailsReportFields.evaluateeId, '', 'Evaluatee Id'),
  new ItemPickerModel(TeamEvaluationDetailsReportFields.evaluateeFirstName, '', 'First Name'),
  new ItemPickerModel(TeamEvaluationDetailsReportFields.evaluateeLastName, '', 'Last Name'),
  new ItemPickerModel(TeamEvaluationDetailsReportFields.evaluateeEmail, '', 'Email'),
  new ItemPickerModel(TeamEvaluationDetailsReportFields.externalSystemId, '', 'External System Id')
];
